import {createApp} from "vue";
const axios = require("axios");
import { Loader } from "@googlemaps/js-api-loader";
import InputSwitch from "./vueComponents/InputSwitch.vue";

export default {
    name: "chat",
    init() {
        this.els = document.querySelectorAll(".js-chat");

        if (!this.els.length) {
            return;
        }
        this.els.forEach((chat) => this.run(chat));
    },

    run(chat) {
        const app = createApp({
            delimiters: ["@{", "}"],
            data() {
                return {
                    eventSource: false,
                    output: "",
                    CSRF_token: window.__CSRF__TOKEN__,
                    input: "",
                    tempOutput: "",
                    axiosController: null,
                    usePosition: false,
                    resource: "",
                    language: ""
                }
            },
            created() {
            },

            computed: {
                suggestions(){
                    let resource = this.getResource() ? 
                    this.getResource().replace(/-./g, x=>x[1].toUpperCase()) : 
                    ['caravans', 'caravanTrailers', 'general'].sort(() => 0.5 - Math.random())[0];

     
                    return this.getSuggestions()[resource].sort(() => 0.5 - Math.random()).splice(0,3);
                },
                inputDisabled(){
                    return this.eventSource;
                },
                hiddenInput() {
                    let text =  ""; 

                    if(!this.usePosition){
                        return "";
                    }
            
                    if(this.locationCity && this.locationPosition){
                       /*  text = "Jeg er i " + this.locationCity + ". "; */
                        text = "Min posisjon: " + this.locationPosition.lat + ',' + this.locationPosition.lng;
                    }
                    return text;
                },
            },

            methods: {
                // SET methods
                setEventSource() {
                    this.eventSource = new EventSource(
                        "/actions/virtual-assistant/actions/stream?" +
                            "input=" + this.getInput() + " " + this.getHiddenInput() +
                            "&resource=" + this.getResource() + 
                            "&lang=" + this.getLanguage()
                    );
                },

                setOutput(data, add = false) {

                    if(add){
                        this.output += data;
                        this.output.replace(/\n/g, '<br>');
                    } else {
                        this.output = data;
                    }
                    
                },

                setIntention() {
                    let token = this.CSRF_token;
                    let input = this.getInput();
                    this.axiosController = new AbortController()
                    let controller = this.axiosController;
                    this.setOutput('<span class="horizontal-loader"></span>');
                    let lang = this.getLanguage();
                    
                    return axios({
                        method: "post",
                        signal: controller.signal,
                        url: "/actions/virtual-assistant/actions/get-intention",
                        data: {
                            CRAFT_CSRF_TOKEN: token,
                            input: input,
                            lang: lang
                        },
                    }).then(res => {
                        this.resource = res.data.intention;
                        this.setOutput(res.data.placeholder ? res.data.placeholder + '<br><br>' : '');
                        this.setOutput(`<span class="horizontal-loader"></span>`, true);
                        
                    });
                },

                setLanguage() {
                    let token = this.CSRF_token;
                    let input = this.getInput();
                    this.axiosController = new AbortController()
                    let controller = this.axiosController;
                    this.setOutput('<span class="horizontal-loader"></span>');
                    
                    return axios({
                        method: "post",
                        signal: controller.signal,
                        url: "/actions/virtual-assistant/actions/get-language",
                        data: {
                            CRAFT_CSRF_TOKEN: token,
                            input: input,
                        },
                    }).then(res => {
                        this.language = res.data.language;
                        this.setOutput(res.data.placeholder ? res.data.placeholder + '<br><br>' : '');
                        this.setOutput(`<span class="horizontal-loader"></span>`, true);
                        
                    });
                },

                setSuggestion(text) {
                    this.input = text;
                    this.ask();
                },

                setGeolocation() {
                    this.usePosition = !this.usePosition;
                    if (navigator.geolocation) {
                        navigator.geolocation.getCurrentPosition(this.setLocationCity.bind(this));
                    }
                },
                setLocationCity(position) {
                    const loader = new Loader({
                        // apiKey: "", // TODO set api key
                        apiKey: "AIzaSyCJV3WaUeG2c7BikmoiJ4CF39PyPuZ1br8",
                        version: "weekly",
                        libraries: ["places", 'geometry']
                    });
                    loader.loadCallback(e => {
                        
                        if (!e) {
                            const geocoder = new google.maps.Geocoder();
                            let latLng = {lat: position.coords.latitude, lng: position.coords.longitude};
                            this.locationPosition = latLng;
                            
                            geocoder.geocode({'location': latLng }, (results, status) => {
                              if (status === google.maps.GeocoderStatus.OK) {
                                if (results[0]){
                                    this.locationCity = results[0].address_components[2].long_name;
                                }else {
                                  console.log('No results found for these coords.');
                                }
                              }else {
                                console.log('Geocoder failed due to: ' + status);
                              }
                        });
                      }
                  })
                },

                // GET methods
                getResource() {
                    return this.resource;
                },
                getLanguage() {
                    return this.language;
                },
                getInput() {
                    return this.input;
                },
                getSuggestions() {
                    return JSON.parse(chat.dataset.suggestions);
                },
                getHiddenInput() {
                    return this.hiddenInput;
                },
                getPositionText() {
                    return this.positionText;
                },

                // RESET methods
                resetEventSource() {

                    if (typeof this.eventSource.close !== "undefined") { 
                        this.eventSource.close();
                    }

                    this.eventSource = false;
                },

                resetChat() {
                    this.resetEventSource();
                    this.resetOutput();
                    this.axiosController.abort();

                },

                resetOutput() {
                    this.resetTempOutput();
                    this.output = "";
                },
                resetTempOutput() {
                    this.tempOutput = "";
                },

                //OTHER methods
                ask() {
                    this.eventSource = "setting resource";
                    this.setLanguage().then(() => {
                        console.log('language: ' + this.language);

                        this.setIntention().then((res) => {
                            console.log('resource: ' + this.resource);
                            console.log("Input: " + this.getInput());
                            console.log("hidden input: " + this.getHiddenInput());
                            this.handleStream();
                        });
                    })
                },

                handleStream() {
                    this.setEventSource();
                    
                    this.eventSource.addEventListener(
                        "message",
                        this._streamOnMessage.bind(this)
                    );

                    this.eventSource.addEventListener(
                        "error",
                        this._streamOnError.bind(this)
                    );
                },

                _streamOnError(e) {
                    axios({
                        method: "get",
                        url: "/actions/virtual-assistant/actions/fallback" +  
                        "?lang=" + this.getLanguage()
                    }).then((response) => {
                        this.setOutput(response.data);
                    });

                    this.resetEventSource();
                },

                _streamOnMessage(event) {
                    if(!this.tempOutput){
                        this.setOutput(`<span class="horizontal-loader"></span>`);
                    }

                    let data = event.data == "[DONE]" ? null : JSON.parse(event.data);

                    if (!data) {
                        this.resetEventSource();
                        this.resetTempOutput();
                        return;
                    }

                    if (data.choices[0].delta.content && data) {
                        this.tempOutput += data.choices[0].delta.content;
                    }

                    try {
                        this.setOutput(this.tempOutput);
                    } catch (error) {
                        axios({
                            method: "get",
                            url: "/actions/virtual-assistant/actions/fallback" + 
                            "?lang=" + this.getLanguage()
                        }).then((response) => {
                            this.setOutput(response.data);
                        });

                        this.resetEventSource();
                    }
                },
            },
        });

        app.component('input-switch', InputSwitch);
        app.mount(chat);
    },
};
